import { render, staticRenderFns } from "./programvod.vue?vue&type=template&id=5fd1fb8d&scoped=true&"
import script from "./programvod.vue?vue&type=script&lang=js&"
export * from "./programvod.vue?vue&type=script&lang=js&"
import style0 from "./programvod.vue?vue&type=style&index=0&id=5fd1fb8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd1fb8d",
  null
  
)

export default component.exports